import {observer} from 'mobx-react-lite'
import React from 'react'
import {useStickerEditorStore} from '../sticker-editor-store'
import {StringStateEdit} from '../string-state-edit/string-state-edit'
import {StringStateItem} from './string-state-item'
import {StringStateItemProps} from './types'

export const StringStateItemWrapper = observer(
  ({stringStickerState}: StringStateItemProps) => {
    const [state] = useStickerEditorStore()
    return (
      <div className="flex items-center justify-between">
        {state.editCurrentState &&
        state.stringState?.id === stringStickerState.id ? (
          <StringStateEdit />
        ) : (
          <StringStateItem stringStickerState={stringStickerState} />
        )}
      </div>
    )
  }
)
